import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "core-js/modules/es.array.concat.js";
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import useUniqueId from 'hooks/useUniqueId';
import Modal from 'components/Modal';
import VisuallyHidden from 'components/VisuallyHidden';
import { ConfirmationModal } from 'screens/ContentEditorModals';
import { getIsActiveTabFromParams } from 'utils/content/getIsActiveTabFromParams';
import { getTabLinkFromParams } from 'utils/content/getTabLinkFromParams';
import SingleAssetManager from './SingleAssetManager';
import MultiAssetManager from './MultiAssetManager';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
function AssetManager(_ref) {
  var inContentManagerContext = _ref.inContentManagerContext,
    hasOpenOption = _ref.hasOpenOption,
    hasPlaylistChanges = _ref.hasPlaylistChanges,
    assets = _ref.assets,
    parentPlaylist = _ref.parentPlaylist,
    onClose = _ref.onClose,
    onSubmit = _ref.onSubmit;
  var titleId = useUniqueId();
  var singleAssetManageLabelId = useUniqueId();
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    hasChanges = _useState2[0],
    setHasChanges = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    hasConfirmationModal = _useState4[0],
    setHasConfirmationModal = _useState4[1];
  function handleClose() {
    if (hasChanges) {
      setHasConfirmationModal(true);
    } else {
      onClose();
    }
  }
  var isSingleAsset = assets.length === 1;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [isSingleAsset ? /*#__PURE__*/_jsxs(Modal, {
      "aria-labelledby": "".concat(singleAssetManageLabelId, " ").concat(titleId),
      onRequestClose: handleClose,
      layout: "top-aligned",
      width: "fullPage",
      children: [/*#__PURE__*/_jsx(VisuallyHidden, {
        id: singleAssetManageLabelId,
        children: t('actions_manage')
      }), /*#__PURE__*/_jsx(SingleAssetManager, {
        inContentManagerContext: inContentManagerContext,
        hasOpenOption: hasOpenOption,
        hasPlaylistChanges: hasPlaylistChanges,
        titleId: titleId,
        asset: assets[0],
        parentPlaylist: parentPlaylist,
        hasChanges: hasChanges,
        setHasChanges: setHasChanges,
        onClose: handleClose,
        onSubmit: onSubmit,
        getIsActiveTab: getIsActiveTabFromParams,
        getTabLink: getTabLinkFromParams
      })]
    }) : /*#__PURE__*/_jsx(Modal, {
      "aria-labelledby": titleId,
      onRequestClose: handleClose,
      layout: "top-aligned",
      width: "fullPage",
      children: /*#__PURE__*/_jsx(MultiAssetManager, {
        titleId: titleId,
        assets: assets,
        parentPlaylistId: parentPlaylist === null || parentPlaylist === void 0 ? void 0 : parentPlaylist.id,
        onClose: onClose,
        onSubmit: onSubmit,
        getIsActiveTab: getIsActiveTabFromParams,
        getTabLink: getTabLinkFromParams
      })
    }), hasConfirmationModal && /*#__PURE__*/_jsx(ConfirmationModal, {
      isEditMode: true,
      isLoading: false,
      onConfirm: function onConfirm() {
        setHasConfirmationModal(false);
        onClose();
      },
      onCancel: function onCancel() {
        return setHasConfirmationModal(false);
      }
    })]
  });
}
export default AssetManager;
export { ShareMultiContentOption } from './MultiAssetManager/MultiAssetHeader';
export { useGetTabInfo } from './useGetTabInfo';